<template>
  <div class="main-con el-main">
    <nav-breadcrumb :menu="[{label: '日均贷款余额表'},{label: '按月每日贷款余额明细'}]"/>
    <el-row class="xzpadd10 bg-purple">
      <data-table
        :tableData="tableData"
        :columns="columns"
        :pageSize.sync="pageSize"
        :page.sync="page"
        :filters="filters"
        :actions="actions"
        :is-pagination-show="false"
      ></data-table>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "FangFinanceAmountByDayList",
      data(){
        return{
          columns:[
            {
              name: '序号',
              type: 'index'
            },
            {
              label: '统计日期',
              field: 't__asOf'
            },
            {
              label: '贷款笔数',
              field: 't__counts'
            },
            {
              label: '日贷款余额',
              field: 't__outstandingAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '操作',
              opts:[
                {
                  label: '贷款明细',
                  class: 'el-icon-view',
                  clickHandler: (index, row)=> {
                    this.$router.push(
                      {
                        path: 'FangFinanceAmountDetailList',
                        query: {
                          asOf: row.t__asOf,
                          outstandingAmount: row.t__outstandingAmount,

                        }
                      }
                    )
                  }
                },
              ]
            }
          ],
          tableData: {
            count: 0,
            data: []
          },
          dealerTypeOptions:[],
          page: 1,
          pageSize: 20,
          actions: [
          ],
          filters: {
            labelWidth: '150px',
            form: {
              dt__deviceType:'',
            },
            columns: [
            ],
            onSubmit:()=>{
              this.page = 1
              this.getData()
            }
          }
        }
      },
      mounted() {
        this.getData()

      },
      computed: {
        filterParams() {
          return {
            pageSize:0,
          }
        }
      },
      watch: {
        filterParams: function (newVal) {
          this.getData()
        }
      },
      methods: {
        getData: function () {
          xhr.getOutstandingDaily(
            Object.assign({month:this.$route.query['asOf']||'',}, this.filterParams, xmlBuildQuery(this.filters)),
            res=> {
              try {
                this.tableData = res.data
              }catch(e){

              }
            })

        },


      }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/FangFinanceAmountByDayList.vue